import { render, staticRenderFns } from "./DesktopColumns.vue?vue&type=template&id=a6e636d8&"
import script from "./DesktopColumns.vue?vue&type=script&lang=js&"
export * from "./DesktopColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports